/**
 * Tutorial guidato dei Dati del negozio.
 *
 * Nessun preparativo: la pagina e' un modulo unico diviso in card e il tutorial non scrive in
 * nessun campo ne' preme Salva.
 */
const SCOPE = '[data-tour-scope="setting-store"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

export function createStoreTourSteps() {
	return [
		{
			body: "Questi sono i dati dell'attivita': il nome con cui il negozio si presenta, il suo sito, la mail di riferimento. Non sono un'etichetta decorativa - finiscono nelle mail ai clienti, nei documenti e in quello che i marketplace mostrano accanto ai tuoi prodotti.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'I dati del negozio',
		},
		{
			body: "Nome, sito e mail dell'attivita'. La mail qui e' quella istituzionale del negozio: e' l'indirizzo da cui il cliente si aspetta di essere ricontattato, diverso dalla casella tecnica con cui il gestionale spedisce.",
			key: 'main',
			placement: 'bottom',
			target: at('main'),
			title: 'Nome, sito e contatto',
		},
		{
			body: "L'indirizzo di spedizione e' anche quello del ritiro in sede: se sul sito hai acceso il ritiro in negozio, e' questo l'indirizzo che il cliente vede e a cui si presenta. Vale la pena che sia scritto come lo scriverebbe un corriere.",
			key: 'shipping',
			placement: 'top',
			target: at('shipping'),
			title: 'Spedizione e ritiro in sede',
		},
		{
			body: 'I dati di fatturazione: ragione sociale, indirizzo, partita IVA e codice fiscale. Sono quelli che finiscono sui documenti emessi e che i servizi di fatturazione elettronica si aspettano di trovare esatti.',
			key: 'invoice',
			placement: 'top',
			target: at('invoice'),
			title: 'I dati di fatturazione',
		},
		{
			body: "Gli orari in cui si lavorano gli ordini, mattina e pomeriggio per ogni giorno. La Board ordini misura i tempi solo dentro queste fasce e salta da sola le festivita' nazionali: cosi' un ordine arrivato la sera non risulta in ritardo la mattina dopo. Il pomeriggio vuoto vale come orario continuato.",
			key: 'hours',
			missing: 'skip',
			placement: 'top',
			target: at('hours'),
			title: 'Orari di lavoro',
		},
		{ body: "Salva, in alto a destra, conferma tutta la pagina in una volta. Finche' non lo premi, quello che hai scritto resta solo a schermo.", key: 'save', placement: 'left', target: at('save'), title: 'Salvare' },
	];
}
